import striptags from 'striptags';

export const sanitizeHTML = (text) => {
  const allowedTags = ['p', 'br', 'b', 'strong', 'i', 'em', 'sub', 'sup', 'q', 'ul', 'ol', 'li'];
  return striptags(text, allowedTags);
};
